import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private Inquiries Types */
import {
  Settings,
  _InquiryPosition,
  InquiryPosition
} from '../namespace-helper'

import _ from 'lodash'

const selectedInquiryPositionTemplate = {
  id: 0,
  internal_number: 0,
  manufacturers_id: 0,
  quantity: 0,
  item_number: '',
  inquiries_position_status_id: 0,
  customer_description: '',
  supplier_description: '',
  manufacturer: {
    name: ''
  },
  unit: {
    code: ''
  }
}

export default {
  namespaced: true,
  state: {
    inquiriesPositions: [],
    inquiriesPositionsCopy: [],
    allInquiriesPositions: [],
    selectedInquiryPosition: _.cloneDeep(selectedInquiryPositionTemplate)
  },
  mutations: {
    [_InquiryPosition.mutations.setInquiriesPositions] (state, payload) {
      state.inquiriesPositions = payload
    },
    [_InquiryPosition.mutations.setInquiriesPositionsCopy] (state, payload) {
      state.inquiriesPositionsCopy = payload
    },
    [_InquiryPosition.mutations.setAllInquiriesPositions] (state, payload) {
      state.allInquiriesPositions = payload
    },
    [_InquiryPosition.mutations.setSelectedInquiryPosition] (state, payload) {
      if (payload !== null) {
        state.selectedInquiryPosition = payload
      } else {
        state.selectedInquiryPosition = _.cloneDeep(selectedInquiryPositionTemplate)
      }
    },
    [_InquiryPosition.mutations.updateInquiriesPositionsCopy] (state, payload) {
      state.inquiriesPositionsCopy = _.cloneDeep(state.inquiriesPositions)
    }
  },
  actions: {
    [_InquiryPosition.actions.saveInquiriesPositions] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload.inquiryPosition)

      if (payload.inquiryPosition.id === 0) {
        var url = API_URL + '/api/v1/inquiryPositions'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          payload.inquiryPosition = null
          store.dispatch(InquiryPosition.actions.loadInquiriesPositions, payload)
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/inquiryPositions/' + payload.inquiryPosition.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          payload.inquiryPosition = null
          store.dispatch(InquiryPosition.actions.loadInquiriesPositions, payload)
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_InquiryPosition.actions.loadInquiriesPositions] (context, payload) {
      console.log('loadInquiriesPositions: ' + JSON.stringify(payload))
      console.log('loadInquiriesPositions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/inquiryPositions/inquiry/' + payload.id + '?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;internal_number:like;item_number:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_InquiryPosition.mutations.setInquiriesPositions, r.data.data)
        context.commit(_InquiryPosition.mutations.setInquiriesPositionsCopy, _.cloneDeep(r.data.data))
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_InquiryPosition.actions.loadAllInquiriesPositions] (context, payload) {
      console.log('loadInquiriesPositions: ' + JSON.stringify(payload))
      console.log('loadInquiriesPositions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/inquiryPositions/inquiry/' + payload.id + '?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;internal_number:like;item_number:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_InquiryPosition.mutations.setAllInquiriesPositions, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_InquiryPosition.actions.deleteInquiriesPositions] (context, payload) {
      var url = API_URL + '/api/v1/inquiryPositions/' + payload.inquiryPosition.id

      console.log('deleteInquiriesPositions: ' + payload.inquiryPosition.id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.dispatch(InquiryPosition.actions.loadInquiriesPositions, payload)
        ErrorHandler.clear(store)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_InquiryPosition.actions.createSupplierRequests] (context, payload) {
      var url = API_URL + '/api/v1/inquirySupplierRequests/inquiry/' + payload.id

      console.log('createSupplierRequests for inquiry: ' + payload.id)

      store.commit(Settings.mutations.setLoading, true)

      axios.post(url, {}, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_InquiryPosition.actions.setSelectedInquiryPosition] ({ commit }, payload) {
      commit(_InquiryPosition.mutations.setSelectedInquiryPosition, payload)
    },
    [_InquiryPosition.actions.updateInquiriesPositionsCopy] (context, payload) {
      context.commit(_InquiryPosition.mutations.updateInquiriesPositionsCopy)
    },
    [_InquiryPosition.actions.resetAllInquiriesPositions] (context) {
      context.commit(_InquiryPosition.mutations.setAllInquiriesPositions, [])
    },
    [_InquiryPosition.actions.resetState] (context) {
      context.commit(_InquiryPosition.mutations.setInquiriesPositions, [])
      context.commit(_InquiryPosition.mutations.setAllInquiriesPositions, [])
      context.commit(_InquiryPosition.mutations.setSelectedInquiryPosition, null)
    }
  },
  getters: {
    [_InquiryPosition.getters.inquiriesPositions] (state) {
      return state.inquiriesPositions
    },
    [_InquiryPosition.getters.inquiriesPositionsCopy] (state) {
      return state.inquiriesPositionsCopy
    },
    [_InquiryPosition.getters.allInquiriesPositions] (state) {
      return state.allInquiriesPositions
    },
    [_InquiryPosition.getters.getSelectedInquiryPosition] (state) {
      return state.selectedInquiryPosition
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/InquiryPositions/inquiriesPositions.js